// extracted by mini-css-extract-plugin
export default {"cls1":"N5WvrSZIug7u6S6FMQNl","cls2":"V3QODogM04QrRoyZlPF4 N5WvrSZIug7u6S6FMQNl"};